import { Navigate, Route, Routes } from "react-router-dom";
import { useProfiles } from "../lib/profiles.js";
import Login from "./Login.js";
import { SignIn } from "./Signin.js";
import Logout from "./Logout.js";
import Sales from "./Sales.js";
import Redeem from "./Redeem.js";
import { BankingInfo } from "./BankingInfo.js";

function WithActiveProfile({ children }) {
  let { active } = useProfiles();
  if (!active) {
    return <Navigate to="/login" />;
  }
  return <>{children}</>;
}

export default function AppRoutes() {
  return <Routes>

    <Route path="/" element={<Navigate to="/home"/>} />
    <Route path="/login" element={<Login />} />
    <Route path="/signin" element={<SignIn />} />
    <Route path="/logout" element={<Logout/>} />{/* // This is going to be a button */}
    <Route path="/home" element={<Navigate to="/sales" />} />
    <Route path="/bnk" element={<Navigate to="/banking-info" />} />
    <Route path="/banking-info" element={<WithActiveProfile><BankingInfo /></WithActiveProfile>}/>
    <Route path="/redeem" element={<WithActiveProfile><Redeem /></WithActiveProfile>} />
    <Route path="/sales" element={<WithActiveProfile><Sales /></WithActiveProfile>} />

  </Routes>

}
